<template>
  <div>
    <b-form-group
      id="input-group-templates"
      label-for="input-Templateses"
      label="Modelos"
    >
      <b-input-group size="sm">
        <b-form-select
          size="md"
          v-model="templateselected"
          :options="templatesoptions"
        >
        </b-form-select>
        <b-input-group-prepend
          is-text
          v-if="templateselected !== 'new template'"
        >
          <input
            type="checkbox"
            v-b-tooltip.hover
            title="Marcar como padrão"
            v-model="templatecheck"
          />
        </b-input-group-prepend>
        <b-input-group-append>
          <b-button
            v-if="templateselected !== 'new template'"
            variant="danger"
            v-b-tooltip.hover
            title="Excluir modelo"
            @click="deletetemplate"
          >
            <b-icon-trash />
          </b-button>
          <b-button
            variant="info"
            :disabled="!templateselected || templateselected == ''"
            @click="salvar"
          >
            <b-icon-file-earmark-check />
            Salvar
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-form-group
      id="input-group-fields"
      label-for="input-fields"
      label="Colunas"
    >
      <b-form-tags
        id="input-fields"
        add-button-text="Incluir"
        add-button-variant="outline-primary"
        placeholder="Adicione as colunas"
        add-on-change
        no-outer-focus
        v-model="fld"
      >
        <template
          v-slot="{ tags, inputAttrs, inputHandlers, disabled, removeTag }"
        >
          <ul v-if="tags.length > 0" class="list-inline d-inline-block mb-2">
            <li v-for="tag in tags" :key="tag" class="list-inline-item">
              <b-form-tag
                @remove="removeTag(tag)"
                :title="tag"
                :disabled="disabled"
                variant="info"
                >{{ tag }}</b-form-tag
              >
            </li>
          </ul>
          <b-form-select
            v-bind="inputAttrs"
            v-on="inputHandlers"
            :disabled="disabled || availableOptions.length === 0"
            :options="fields"
          >
            <template #first>
              <!-- This is required to prevent bugs with Safari -->
              <option disabled value="">
                Selecione as colunas a serem exportadas
              </option>
            </template>
          </b-form-select>
        </template>
      </b-form-tags>
    </b-form-group>

    <b-row>
      <b-col cols="12" lg="3">
        <b-form-group
          id="input-group-filename"
          label-for="input-filename"
          label="Nome Arquivo"
        >
          <b-form-input id="input-filename" v-model="filename"> </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="2">
        <b-form-group
          id="input-group-extensao"
          label-for="input-extensao"
          label="Extensão"
        >
          <b-form-select id="input-extensao" :options="extensoes" v-model="ext">
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="2">
        <b-form-group
          id="input-group-separador"
          label-for="input-separador"
          label="Separador"
        >
          <b-form-select
            id="input-separador"
            :options="separators"
            v-model="sep"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="1">
        <b-form-group
          id="input-group-quoted"
          label-for="input-quoted"
          label="Formatador"
        >
          <b-form-input id="input-quoted" v-model="quoted"> </b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" lg="2">
        <b-form-group
          id="input-group-quoted"
          label-for="input-quoted"
          label="Finalizador"
        >
          <b-form-select
            id="input-finalizador"
            :options="finalizadores"
            v-model="fin"
          >
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="6" lg="1">
        <b-form-group
          id="input-group-head"
          label-for="input-head"
          label="Cabeçalho"
        >
          <b-form-checkbox id="input-head" v-model="whead" switch>{{
            lcabecalho
          }}</b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col cols="6" lg="1">
        <b-form-group
          id="input-group-head"
          label-for="input-head"
          label="Finalizar"
        >
          <b-form-checkbox v-model="sepfin" switch>{{
            lfinalizar
          }}</b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group
      id="input-group-csvstream"
      label-for="input-csvstream"
      label="Exemplo"
    >
      <b-form-textarea
        id="input-csvstream"
        :value="csvsample"
        disabled
        debounce="1000"
        wrap="off"
        rows="8"
        style="font-family: revert; font-size: 10px; font-weight: bold"
      ></b-form-textarea>
    </b-form-group>
    <hr />
    <span class="spaced">
      <b-button
        :disabled="csvstream == ''"
        variant="primary"
        class="float-right"
        @click="download"
      >
        <b-icon-download />
        Baixar
      </b-button>
    </span>
    <!-- MODALS -->
    <b-modal
      id="modal-template"
      ref="modal-template"
      title="Salvar modelo"
      ok-only
      ok-title="Salvar"
      :ok-disabled="templatename == ''"
      @ok="savetemplate"
    >
      <b-form-group
        id="input-group-nome"
        label-for="input-nome"
        label="Nome do modelo"
      >
        <b-form-input id="input-nome" v-model="templatename"> </b-form-input>
      </b-form-group>
    </b-modal>

    <!-- 
      fld: {{ fld }}<br />
      datafiltered: {{ datafiltered }}<br />
      ext: {{ ext }}<br />
      filename: {{ filename }}<br />
      filenameext: {{ filenameext }}<br />
    templatesoptions: 
    <pre>
      {{ templatesoptions }}<br />
    </pre>
    <pre>
    </pre>
    <pre>
      templates:
      {{ templates }}
    </pre>
    templateselected:
    {{ templateselected }}<br />
    templatedefault:
    {{ templatedefault }}<br />
    {{ csvstream }}
  --></div>
</template>

<script>
import API from "../services/apiservices";
import * as XLSX from "xlsx";

export default {
  name: "ExportFile",

  data() {
    return {
      templates: [],
      templatename: "",
      templateselected: "new template",
      templatedefault: "",
      addfld: "",
      sep: this.value.sep || ";",
      ext: this.value.ext || "CSV",
      sepfin: this.value.sepfin || true,
      fin: this.value.fin || "\r\n",
      fld: this.value.fld,
      quoted: this.value.quoted || "",
      whead: this.value.whead || "",
      csvstream: this.value.csvstream || "",
      filename: this.value.filename || "",
      data: this.value.data || [],
      storeName: this.$router.history.current.name,
    };
  },

  props: {
    value: {
      type: Object,
    },
  },

  computed: {
    lcabecalho() {
      return this.whead ? "Sim" : "Não";
    },
    lfinalizar() {
      return this.sepfin ? "Sim" : "Não";
    },
    fields() {
      return this.data.length > 0
        ? Object.keys(this.data[0]).filter((f) => this.fld.indexOf(f) === -1)
        : [];
    },
    datafiltered() {
      return this.fld.length == 0
        ? this.data
        : this.data.map((obj) => {
            return Object.fromEntries(this.fld.map((key) => [key, obj[key]]));
          });
    },
    availableOptions() {
      return this.fields.filter((opt) => this.fld.indexOf(opt) === -1);
    },
    separators() {
      return ["", ",", ";", "|"];
    },
    extensoes() {
      return ["", "CSV", "TXT", "XLSX"];
    },
    finalizadores() {
      const fin = [
        { value: "\r\n", text: "LF+CR" },
        { value: "\n", text: "LF" },
      ];
      // fin.push({ value: this.sep, text: this.sep });
      return fin;
    },
    emitmodal() {
      return {
        sep: this.sep,
        ext: this.ext,
        fld: this.fld,
        quoted: this.quoted,
        whead: this.whead,
        filename: this.filename,
        data: this.data,
      };
    },
    templatemodel() {
      return {
        sep: this.sep,
        ext: this.ext,
        fld: this.fld,
        quoted: this.quoted,
        whead: this.whead,
      };
    },
    templatesoptions() {
      const template =
        this.templates.length > 0
          ? this.templates.map((m) => ({ value: m.nome, text: m.nome }))
          : [];
      template.unshift({ value: "new template", text: "Novo Modelo" });
      return template;
    },
    csvsample() {
      return this.data.length > 0
        ? this.json2csv(
            this.data.filter((f, i) => i < 5),
            this.fld,
            this.sep,
            this.quoted,
            this.whead,
            this.fin,
            this.sepfin
          )
        : "";
    },
    templatecheck: {
      get() {
        return this.templatedefault == this.templateselected;
      },
      set(value) {
        // console.log("templatecheck:", value);
        this.templatedefault = value ? this.templateselected : "";
        this.savetemplate();
      },
    },
    filenameext() {
      const filename = this.filename || "ArquivoExport";
      const ext = this.ext !== "" ? "." + this.ext.toLowerCase() : "";
      return filename + ext;
    },
  },

  watch: {
    emitmodal: {
      deep: true,
      handler(data) {
        this.exporta(data);
      },
    },
    templateselected(nome) {
      const template = this.templates.find((f) => f.nome == nome);
      if (template) {
        this.fld = template.fld;
        this.sep = template.sep;
        this.ext = template.ext;
        this.quoted = template.quoted;
        this.whead = template.whead;
        this.templatename = nome;
      }
    },
    // ext(n, o) {
    //   if (n !== "") {
    //     const ext = `.${n.toLowerCase()}`;
    //     const old = `.${o.toLowerCase()}`;
    //     this.filename = this.filename.toLowerCase().replaceAll(old, ext);
    //   }
    // },
  },

  beforeMount() {
    if (this.value.storeName && this.value.storeName !== "") {
      this.storeName = this.value.storeName;
    }

    // pega do indexDB
    API.getLocalDBDocument(`${this.storeName}ExportFile`).then((doc) => {
      // console.log("beforeMount.doc:", doc);
      if (doc && doc.data) {
        this.templates = doc.data;
        if (doc.templatedefault) {
          this.templateselected = doc.templatedefault || "new template";
          this.templatedefault = doc.templatedefault || "new template";
        }
      }
    });

    //let templates = localStorage.getItem("templatesexport");
    //if (templates && templates !== "") {
    //  this.templates = JSON.parse(templates).filter((f) => f);
    //}

    this.updatecsv();
  },

  methods: {
    updatecsv() {
      this.csvstream = this.json2csv(
        this.data,
        this.fld,
        this.sep,
        this.quoted,
        this.whead,
        this.fin,
        this.sepfin
      );
    },
    exporta(data) {
      this.updatecsv();
      const emitdata = { ...data, ...{ csvstream: this.csvstream } };
      this.$emit("input", emitdata);
    },
    download() {
      if (this.ext == "XLSX") {
        this.exportToExcel(this.datafiltered, this.filenameext);
      } else {
        this.downloadString(this.csvstream, this.filenameext);
      }
    },
    json2csv(
      obj,
      fld = null,
      sep = ";",
      quoted = "",
      whead = true,
      fin = "\r\n",
      sepfin = true
    ) {
      let csv = [];
      if (obj.length > 0) {
        const replacer = (key, value) => (value === null ? "" : value); // specify how you want to handle null values here

        let header = [];

        if (Array.isArray(fld) && fld.length > 0) {
          header = fld;
        } else {
          header = Object.keys(obj[0]);
        }

        // header = header.filter(
        //   (f) =>
        //     !(
        //       Array.isArray(obj[0][f]) ||
        //       typeof obj[0][f] === "object" ||
        //       (typeof obj[0][f] === "object" && !(obj[0][f] instanceof Date))
        //     )
        // ); // não trazer os campos array

        // console.log("header:", header);

        csv = [
          ...obj.map(
            (row) =>
              header
                .map((fieldName) => {
                  // console.log("fieldName:", fieldName);
                  if (row[fieldName] !== undefined) {
                    return (
                      quoted +
                      JSON.stringify(row[fieldName], replacer)
                        .toString()
                        .replaceAll('"', "") +
                      // JSON.stringify(row[fieldName]) +
                      //JSON.stringify(row[fieldName], replacer) +
                      //(row[fieldName] || "ABC").toString().replaceAll('"', "") +
                      quoted
                    );
                  } else {
                    return "";
                  }
                })
                .join(sep) + (sepfin ? sep : "")
          ),
        ].join(fin);

        if (whead) csv = header.join(sep) + (sepfin ? sep : "") + fin + csv;
        // header.join(sep) + this.sepfin == true ? sep : "" + fin + csv;

        // console.log("json2csv.obj:", obj);
        // console.log("json2csv.fld:", fld);
        // console.log("json2csv.sep:", sep);
        // console.log("json2csv.quoted:", quoted);
        // console.log("json2csv.whead:", whead);
        // console.log("json2csv.csv:", csv.substring(0, 100));
      }
      return csv;
    },
    downloadString(strContent, fileName) {
      if (!fileName)
        fileName = Math.random().toString(36).split(".")[1] + ".dat";
      // var encodedUri = encodeURI(strContent);
      var encodedUri = encodeURIComponent(strContent);
      var link = document.createElement("a");
      link.setAttribute("href", "data:text/plain;charset=utf-8," + encodedUri);
      link.setAttribute("download", fileName);
      link.style.display = "none";
      document.body.appendChild(link); // Required for FF

      link.click(); // This will download the data file named "my_data.csv".

      this.$root.toastsuccess("Arquivo gerado com sucesso !");

      document.body.removeChild(link);
    },
    exportToExcel(data, filename = "Relatório") {
      // Verifica se está exibindo itens com ou sem nota
      if (data.length === 0) {
        alert("Nenhum dado disponível para exportar.");
        return;
      }

      // Preparar os dados no formato de planilha
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Plan1");

      // Gerar e baixar o arquivo Excel
      XLSX.writeFile(workbook, filename);
    },
    salvar() {
      if (this.templateselected == "new template") {
        this.templatename = "";
        this.$refs["modal-template"].show();
      } else {
        if (this.templatename !== "") {
          this.savetemplate();
        }
      }
    },
    savetemplate() {
      const template = {
        nome: this.templatename,
        ...this.templatemodel,
      };
      const founded = this.templates.find((f) => f.nome == template.nome);

      if (!founded) {
        this.templates.push(template);
      } else {
        founded.whead = this.whead;
        founded.fld = this.fld;
        founded.sep = this.sep;
        founded.quoted = this.quoted;
        founded.whead = this.whead;
        founded.ext = this.ext;
      }

      // salva no indexDB
      API.setLocalDBDocument(
        {
          data: this.templates,
          templatedefault: this.templatedefault || "new template",
        },
        `${this.storeName}ExportFile`
      );

      localStorage.setItem("templatesexport", JSON.stringify(this.templates));

      this.templateselected = this.templatename;

      this.$root.toastsuccess("Modelo salvo com sucesso !");
    },
    deletetemplate() {
      this.$root
        .showmessage(
          `Confirma a exclusão do modelo "${this.templateselected}" ?`
        )
        .then((sim) => {
          if (sim) {
            const i = this.templates.findIndex(
              (f) => f.nome == this.templateselected
            );
            if (i > -1) {
              this.fld = null;
              this.templateselected = "new template";
              this.templates.splice(i, 1);
            }

            API.setLocalDBDocument(
              { data: this.templates },
              `${this.storeName}ExportFile`
            );
          }
        });
    },
    favoritar(value) {
      // console.log("favoritar", value.target.value);
      this.templatedefault = this.templateselected;
    },
  },
};
</script>
